import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { flexbox, flexDirection, alignItems } from '../../styles/helpers/flexbox';

const ModalBody = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
  ${flexbox()};
  ${flexDirection('column')};
  ${alignItems('flex-start')};

  * {
    color: ${colours.grey[900]}
  }

  .title{
    margin-bottom: 15px;
    font-size: 18px;
  }

  .previewButton {
    background-color: #c3d5e1 !important;
    border: 1px solid #c3d5e1 !important;
    color: #3b4e5e !important;
    margin-top: 10px;
    padding: 2px 16px;
  }
  `;
});

const Tabs = styled.div(() => `
  ${flexbox()};
  ${flexDirection('row')};

    width: 100%;
    justify-content: space-between;
    
    .subTitle {
      font-size: 14px;
      margin-right: 12px;
      font-weight: 600;
      vertical-align: 14px;
    }

    button {
      margin-right: 12px;
      border: 1px solid #E6E9EA;
      border-bottom: none
      outline: none;
      cursor: pointer;
      padding: 10px 10px 13px;
      font-size: 17px;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      background: #E6E9EA
      width: 70px;
      height: 56px;
      position: relative;
    }

    .active {
      background: white;
      border: 1px solid #E6E9EA;

      ::after {
        content: '';
        position: absolute;
        background: white;
        width: 68px;
        height: 6px;
        bottom: -3px;
        left: 0;
      }
    }

    .whatsThisCallout {
      position: absolute;
      padding: 10px;
      width: 265px;
      border-radius: 5px;
      top: 120px;
      font-size: 14px;
      right: 40px;
      box-shadow: 4px 2px 6px;
      background: white;
      z-index: 8;

      ::after {
        width: 0; 
        height: 0; 
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;        
        border-bottom: 15px solid white;
        position: fixed;
        top: 106px;
        right: 92px;
        content: ' '
      }
    }
  `);

const Content = styled.div(() => `
    ${flexbox()};
    ${flexDirection('row')};

    min-height: 250px;
    max-height: 450px;
    border: 1px solid #E6E9EA;
    width: 97%;
    border-radius: 10px;
    padding: 15px;
    text-align: left;
    font-size: 15px;
    overflow-y: auto;

    .heading {
      font-weight:600;
      margin-top: 25px
    }
    .subHeading{
      margin: 8px 0
    }
    .list {
      list-style-type: disc;
      list-style-position: outside;
      margin-left: 18px;
      line-height: 22px;
    }
    .demo {
      display: inline-flex
    }
  `);

const Description = styled.div(() => `
    ${flexbox()};
    ${flexDirection('column')};
    
    width: 40%;
  `);

const Questions = styled.div(() => `
    width: 60%;
    margin: 20px 0 0 50px;
    border: 1px solid #E6E9EA;
  `);

export { ModalBody, Tabs, Content, Description, Questions };



// WEBPACK FOOTER //
// ./components/upf-assign-preview-modal/styled.js